var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.021 29.764.49-.476a.791.791 0 0 0 0-1.141L4.16 16.143h26.01c.458 0 .83-.361.83-.807v-.672a.819.819 0 0 0-.83-.807H4.16L16.51 1.853a.791.791 0 0 0 0-1.141l-.489-.476a.847.847 0 0 0-1.174 0L.243 14.43a.791.791 0 0 0 0 1.142l14.604 14.193a.847.847 0 0 0 1.174 0Z",
    fill: "#53565A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.6446a4e280a0d5d04bbf28994667e2f9.svg";
export { ForwardRef as ReactComponent };